/*
 *
 * PriceListMaster constants
 *
 */

export const DEFAULT_ACTION = 'app/PriceListMaster/DEFAULT_ACTION';
